import React, { useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import Snackbar from "@material-ui/core/Snackbar";

const ConfirmAndPay = ({
  userInfo,
  setUserInfo,
  selectedSizeRug,
  pay,
  successPay,
  themeDirection,
  texts,
  trackingCode,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [isOpenSnack, setIsOpenSnack] = useState(false);
  return successPay ? (
    <div style={{ padding: isMobile ? "60px 20px 60px" : "100px 20px 100px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DoneRoundedIcon style={{ color: "#06b170", fontSize: "10rem" }} />
        <p style={{ color: "#06b170" }}>
          تبریک <br />
          سفارش شما با موفقیت ثبت شد
        </p>
      </div>
      <div
        style={{
          display: "flex",
          borderRadius: 25,
          position: "absolute",
          backgroundColor: "#f8f8f8",
          bottom: isMobile ? 62 : 72,
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <div
          style={{
            borderRadius: 25,
            padding: isMobile ? "10px 25px" : "10px 40px",
            display: "flex",
            whiteSpace: "nowrap",
            backgroundColor: "#06b170",
            color: "#fff",
          }}
        >
          کد پیگیری
        </div>
        <button
          style={{
            borderRadius: 25,
            width: 200,
            backgroundColor: "#f8f8f8",
          }}
        >
          {trackingCode}
        </button>
      </div>
      <button
        style={{
          borderRadius: 25,
          width: 200,
          backgroundColor: "#06b170",
          position: "absolute",
          bottom: -20,
          right: 0,
          left: 0,
          height: 40,
          color: "#fff",
        }}
        onClick={() => {
          navigator.clipboard.writeText(trackingCode);
          setIsOpenSnack(true);
        }}
      >
        کپی کد پیگیری
      </button>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        message="کد پیگیری با موفقیت کپی شد"
        autoHideDuration={3000}
      />
    </div>
  ) : (
    <div style={{ padding: isMobile ? "60px 20px 60px" : "120px 20px 120px" }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            justifySelf: "start",
            margin: 0,
            textAlign: themeDirection == "ltr" ? "left" : "right",
          }}
        >
          <p>{texts.name_and_lastname} :</p>
          <input
            placeholder={texts.name_and_lastname}
            style={{
              backgroundColor: "#f8f8f8",
              marginTop: 10,
              width: "100%",
              fontSize: 18,
              padding: 15,
              borderRadius: 4,
            }}
            value={userInfo.name}
            onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
          />
        </div>
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            justifySelf: "end",
            margin: 0,
            textAlign: themeDirection == "ltr" ? "left" : "right",
          }}
        >
          <p>{texts.Phone_call} :</p>
          <input
            placeholder={texts.Phone_call}
            style={{
              backgroundColor: "#f8f8f8",
              marginTop: 10,
              width: "100%",
              fontSize: 18,
              padding: 15,
              borderRadius: 4,
            }}
            value={userInfo.phone}
            onChange={(e) =>
              setUserInfo({ ...userInfo, phone: e.target.value })
            }
          />
        </div>
        <div
          style={{
            width: "100%",
            textAlign: themeDirection == "ltr" ? "left" : "right",
            marginTop: 30,
          }}
        >
          <p>{texts.Address} :</p>
          <input
            placeholder={texts.Address}
            style={{
              backgroundColor: "#f8f8f8",
              marginTop: 10,
              width: "100%",
              fontSize: 18,
              padding: 15,
              borderRadius: 4,
            }}
            value={userInfo.address}
            onChange={(e) =>
              setUserInfo({ ...userInfo, address: e.target.value })
            }
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          borderRadius: 25,
          position: "absolute",
          backgroundColor: "#f8f8f8",
          bottom: isMobile ? 62 : 72,
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <button
          style={{
            borderRadius: 25,
            height: 45,
            width: 200,
            backgroundColor:
              userInfo.name && userInfo.phone && userInfo.address
                ? "#2bc595"
                : "#b9b9b9",
            color: "#fff",
          }}
          disabled={!userInfo.name || !userInfo.phone || !userInfo.address}
          onClick={pay}
        >
          {texts.submit}
        </button>
      </div>
    </div>
  );
};

export default ConfirmAndPay;
